import {resetRouter} from '@/router'

export function resetTokenAndClearUser() {
    // 退出登陆 清除用户资料
    sessionStorage.clear()
    // 重设路由
    resetRouter()
}

export const defaultDocumentTitle = ''

export function getDocumentTitle(pageTitle) {
    const merchantInfo = sessionStorage.getItem('merchantInfo')
    if (merchantInfo) {
        let logoName = JSON.parse(merchantInfo).logoName
        if (!logoName) {
            logoName = ''
        }
        if (pageTitle) return `${logoName} - ${pageTitle}`
        return `${logoName}`
    }
    return '登录'
}
